import { FC } from 'react'

import { Checkbox, FormControlLabel, Typography } from '@mui/material'
import { AutoCompleteOption } from '@/components/inputs/LicenseCompetitionsAutocomplete/LicenseCompetitionsAutocomplete'

type CompetitionCheckboxItemProps = {
  competition: AutoCompleteOption
  isSelected: boolean
  onToggle: (competition: AutoCompleteOption) => void
}

export const CompetitionCheckboxItem: FC<CompetitionCheckboxItemProps> = ({
  competition,
  isSelected,
  onToggle
}) => {
  return (
    <FormControlLabel
      control={<Checkbox checked={isSelected} onChange={() => onToggle(competition)} />}
      label={
        <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
          {competition.label}
        </Typography>
      }
      sx={{
        px: 2,
        py: 0.5,
        '&:hover': {
          bgcolor: 'action.hover'
        },
        mr: 0,
        width: '100%',
        ml: 0
      }}
    />
  )
}
